<template>
    <ion-item fill="outline" class="containers" :class="{ 'border-danger': errors }">
        <ion-input 
            @input="$emit('update:modelValue', $event.target.value)" 
            :type="inputType" :value='modelValue' class="password-input" :placeholder="placeholder">
        </ion-input>
        <ion-button
            fill="clear"
            slot="end"
            class="password-display-button"
            @click="changeInputType"
        >
            <ion-icon :icon="isPasswordHidden ? eyeOutline : eyeOffOutline"></ion-icon>
        </ion-button>
    </ion-item>
</template>

<script setup lang="ts">
    import { TextFieldTypes } from '@ionic/core';
import {
        IonButton,
        IonInput,
        IonIcon,
        IonItem,
    } from '@ionic/vue'
    import { eyeOutline, eyeOffOutline } from 'ionicons/icons';
    import { ref, computed, watch } from 'vue';

    const props = defineProps(['placeholder', 'errors', 'modelValue'])
    defineEmits(['update:modelValue'])
    const isPasswordHidden = ref(true)

    const inputType = computed(():  TextFieldTypes => {
        return isPasswordHidden.value ? "password" : "text"
    })

    function changeInputType(event: Event) {
        isPasswordHidden.value = !isPasswordHidden.value
    }
</script>

<style scoped>

ion-item {
    --margin-bottom:0;
}
ion-input {
    /* --border-color: var(--ion-color-light-contrast);
    --border-style: solid;
    --border-width: 3px;
    --padding-bottom: 10px;
    --padding-end: 10px;
    --padding-start: 10px;
    --padding-top: 10px; 

    --background-color: var(--ion-color-light-shade);

    --placeholder-color:  var(--ion-color-light-contrast);
    --placeholder-opacity: 0.4; */
}
.containers {
    /* height: 39px; */
    --inner-padding-top: 0px;
    --padding-start: 10px;
    --inner-padding-end: 10px;
    --min-height: 44px;
    overflow: visible;
    --background: var(--ion-color-light-tint);

}
ion-input.password-input {
    flex: 1;
    height: 100%;
    /* --color: var(--ion-color-light); */
    margin: 0 0 0 0;

    --border-style: solid;
    --border-width: 3px;
    --padding-bottom: 10px;
    --padding-end: 10px;
    --padding-start: 10px;
    --padding-top: 10px; 

    /* --background-color: var(--ion-color-light-shade); */

    --placeholder-color:  var(--ion-color-light-contrast);
    --placeholder-opacity: 0.4;
}

.password-display-button {
    height: 100%;
    border: none;
    margin: 0 0 0 0;
    --color: var(--ion-color-light-contrast);
}

.border-danger {
    --border-color: red;
    --border-width: 1px;
    border-radius: 5px;
}
</style>
